export default __webpack_public_path__ + "9f673c1d521f607dc30fe4d6bf452c87.png";